import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ReferenceDataProvider from '~/utils/reference-data/context';

const GenericReferenceData = () => {
  const { type } = useParams();

  return (
    <ReferenceDataProvider
      type={type}
      config={{
        components: {
          beforeCollection: (
            <p>
              <Link to="/toolbox/generic">
                <FontAwesomeIcon icon="chevron-left" />
                <span className="d-none d-md-inline ml-2">Back to List</span>
              </Link>
            </p>
          ),
        },
      }}
    />
  );
};

export default GenericReferenceData;
